module.exports = __webpack_public_path__ + "images/emoji/clock430.19ef1760e95387857141.png";